/* Fills print swatches with fabric. Each print chip shows a zoomed crop of the product photo; this
   script finds a trouser leg at thigh height (the run of non-background pixels nearest the centre
   line), then sets the zoom and position so the chip shows only that leg's fabric. */
(() => {
  const cache = new Map();

  function locate(url) {
    if (cache.has(url)) return cache.get(url);
    const job = new Promise((resolve) => {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = () => {
        try {
          const w = 120;
          const h = Math.round((img.naturalHeight / img.naturalWidth) * w) || 150;
          const canvas = document.createElement('canvas');
          canvas.width = w;
          canvas.height = h;
          const ctx = canvas.getContext('2d', { willReadFrequently: true });
          ctx.drawImage(img, 0, 0, w, h);
          const bg = ctx.getImageData(2, 2, 1, 1).data;
          let pick = null;
          for (const fy of [0.5, 0.46, 0.54, 0.42, 0.58, 0.38]) {
            const y = Math.round(fy * h);
            const row = ctx.getImageData(0, y, w, 1).data;
            const runs = [];
            let start = -1;
            for (let x = 0; x <= w; x++) {
              let on = false;
              if (x < w) {
                const i = x * 4;
                const d = Math.abs(row[i] - bg[0]) + Math.abs(row[i + 1] - bg[1]) + Math.abs(row[i + 2] - bg[2]);
                on = d > 40;
              }
              if (on && start < 0) start = x;
              if (!on && start >= 0) {
                if (x - start >= w * 0.05) runs.push({ a: start, b: x });
                start = -1;
              }
            }
            if (!runs.length) continue;
            runs.sort((r1, r2) => Math.abs((r1.a + r1.b) / 2 - w / 2) - Math.abs((r2.a + r2.b) / 2 - w / 2));
            const r = runs[0];
            const len = r.b - r.a;
            pick = { cx: (r.a + r.b) / 2 / w, cy: fy, len: len / w, ratio: h / w };
            break;
          }
          resolve(pick);
        } catch (e) {
          resolve(null);
        }
      };
      img.onerror = () => resolve(null);
      img.src = url;
    });
    cache.set(url, job);
    return job;
  }

  function apply(chip) {
    if (chip.dataset.klDone) return;
    chip.dataset.klDone = '1';
    const src = chip.dataset.klSrc;
    if (!src) return;
    locate(src).then((spot) => {
      if (!spot) return;
      // Show about 60% of the leg's width so no background reaches the chip edge.
      const zoom = Math.min(24, Math.max(8, 1 / (spot.len * 0.6)));
      const pos = (f, scale) => Math.min(100, Math.max(0, ((scale * f - 0.5) / (scale - 1)) * 100));
      chip.style.backgroundImage = `url("${src}")`;
      chip.style.backgroundSize = `${zoom * 100}%`;
      chip.style.backgroundPosition = `${pos(spot.cx, zoom).toFixed(2)}% ${pos(spot.cy, zoom * spot.ratio).toFixed(2)}%`;
    });
  }

  // Only fetch a chip's photo when it is about to scroll into view.
  const io = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            io.unobserve(e.target);
            apply(e.target);
          }
        });
      }, { rootMargin: '200px 0px' })
    : null;

  function scan(root) {
    root.querySelectorAll('[data-kl-chip]').forEach((chip) => {
      if (chip.dataset.klDone || chip.dataset.klSeen) return;
      chip.dataset.klSeen = '1';
      if (io) io.observe(chip);
      else apply(chip);
    });
  }

  const start = () => {
    scan(document);
    new MutationObserver((records) => {
      for (const r of records) r.addedNodes.forEach((n) => n.nodeType === 1 && scan(n));
    }).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* Krazy Larry: normalise product-card photo framing so every pant appears the same size.
   Map: image filename -> [scale, translateX %, translateY %] (measured waist-to-feet framing). */
(function () {
  var M = {"2fe5478b8351a583e1f8a1e917f04a8f627a0e49cf4fe23b4399c80f96fe8176.png":[1.3,-15.54,-32.28],"73ed708485a1316f27020058f1e85ab75fda341302af88640d85bceaddf48897_7047f29b-e673-4a14-baef-8153b576c31b.jpg":[1.145,-4.86,-5.9],"973afef48c5b0baa04d13ca11e8d543fc2f935551e0e31f9a5525a196bb238c9.png":[1.3,-17.71,-27.94],"2b2b31e38fa7725d83ef754a654a6fad27755b086f8ac730ea3aabee47fb2102_4241ca2e-2d38-4772-92ac-9fbfda9f5610.jpg":[1.062,-3.96,-4.44],"P600-BLUE-DENIM_1_ProductBeautifier.png":[1.169,-7.5,-13.71],"P600-BROWN.jpg":[1.19,-8.99,-15.62],"P600-TOFFEE.jpg":[1.179,-8.48,-14.66],"P600-OLIVE_e9baea8e-373c-4fe2-8876-76ccefd79430.jpg":[1.16,-7.5,-12.78],"3_ProductBeautifier_4db7635b-c6c9-4e72-bf17-33f5af4eb4b3.jpg":[1.124,-3.84,-9.33],"2.jpg":[1.169,-5.06,-11.37],"1_ProductBeautifier.jpg":[1.124,-4.31,-9.33],"P507-IVORY_PAISLEY-0.jpg":[1.3,-12.29,-24.33],"P507-BROWN_LEOPARD-0_35773d88-9432-4e69-90ec-90044fde736b.jpg":[1.087,-5.69,-4.42],"P600-0_2.jpg":[1.113,-5.18,-6.87],"P600-0_1.jpg":[1.104,-3.82,-6.04],"P600-0.jpg":[1.113,-3.79,-6.87],"P21-CREAM-0.jpg":[1.169,-7.99,-12.15],"P21-COBALT-0.jpg":[1.078,-3.46,-3.63],"51UAmWpgmmL._AC_SY879.jpg":[1.045,-0.53,-1.97],"71bGVS3fITL._AC_SR1472_1840.jpg":[1.053,-4.43,-2.73],"P507-Black-french-news.png":[1.3,-18.79,-27.8],"P507-Sketch-2_049a3857-3496-4ca2-9757-cfc557572b13.png":[1.078,-16.93,-6.5],"p507-tuscan.jpg":[1.062,-7.5,-7.74],"p507-taupe-tiger.jpg":[1.045,-6.63,-6.15],"p507-pink-rocks.jpg":[1.062,-10.6,-7.74],"p507-passport.jpg":[1.211,-7.5,-22.44],"p507-multi-squares.jpg":[1.045,-2.27,-6.15],"p507-mini-flowers.jpg":[1.062,4,-7.74],"p507-military-splatter.jpg":[1.078,-3.46,-9.38],"p507-lipstick.jpg":[1.14,-7.98,-15.53],"p507-lime-polka-dot.jpg":[1.07,7.66,-8.55],"p507-lime-firecracker.jpg":[1.087,-1.61,-9.49],"p507-indigo.jpg":[1.095,-2.94,-2.3],"p507-hexagon.jpg":[1.053,-3.99,-6.94],"p507-gold-chain.jpg":[1.104,-4.28,-11.93],"p507-circles.jpg":[1.131,-13.16,-14.61],"p507-brown-leopard.jpg":[1.053,-1.79,-6.94],"p507-black-zebra.jpg":[1.3,-14.46,-31.27],"p507-black-flamingo.jpg":[1.07,-0.37,-8.55],"p507-black-cubed.jpg":[1.104,-5.2,-11.93],"p507-black-bars.jpg":[1.053,-4.43,-6.94],"p507-black-mini-flowers.jpg":[1.07,-0.81,-7.84],"p507-lilac-flowers.jpg":[1.07,0.08,-8.55],"p507-lime-flowers.jpg":[1.062,1.79,-7.74],"3BCE620F-9CCD-45FA-BBA0-D4B4BB7B9EE2.jpg":[1.113,-6.11,-9.84],"1BA03FCD-BE78-4464-8BFD-6E69E5F90D75.jpg":[1.113,-3.79,-6.87],"p607-pinkdenim.jpg":[1.078,-1.21,-9.38],"p907-paisley_Product_Beautifier.jpg":[1.3,-17.71,-26.07],"p907-hexagon_Product_Beautifier.jpg":[1.062,-4.85,-3.49]};
  function key(img) {
    var s = img.getAttribute('src') || img.currentSrc || '';
    return s.split('?')[0].split('/').pop();
  }
  function fit(img) {
    if (img.dataset.klFit) return;
    var t = M[key(img)];
    img.dataset.klFit = t ? '1' : '0';
    if (!t) return;
    img.parentElement.style.overflow = 'hidden';
    img.style.transformOrigin = '0 0';
    img.style.transform = 'translate(' + t[1] + '%,' + t[2] + '%) scale(' + t[0] + ')';
  }
  function run(root) {
    (root || document).querySelectorAll('.card-gallery img.product-media__image, .kl-fc__media img').forEach(fit);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(); });
  else run();
  new MutationObserver(function (ms) {
    for (var i = 0; i < ms.length; i++) if (ms[i].addedNodes.length) { run(); break; }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* Krazy Larry: the Frequently Bought Together app (cbb) injects its widget at the bottom of the
   page. Move it into the theme's app block slot, which sits under the product gallery. */
(function () {
  function place() {
    var slot = document.getElementById('frequently-bought-together-app-block');
    if (!slot) return false;
    var widgets = document.querySelectorAll('.cbb-frequently-bought-container');
    widgets.forEach(function (w) {
      if (!slot.contains(w)) slot.appendChild(w);
    });
    return widgets.length > 0;
  }
  if (!document.getElementById('frequently-bought-together-app-block') && document.readyState !== 'loading') return;
  var obs = new MutationObserver(function () { place(); });
  function start() {
    if (!document.getElementById('frequently-bought-together-app-block')) return;
    place();
    obs.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 20000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

/* Krazy Larry: mega menu tile images are rendered without src (data-kl-src) so they do not download
   on every page. Load them the first time a shopper reaches for the menu. */
(function () {
  function load() {
    document.querySelectorAll('img[data-kl-defer][data-kl-src]').forEach(function (img) {
      var ss = img.getAttribute('data-kl-srcset');
      var s = img.getAttribute('data-kl-src');
      if (ss) img.setAttribute('srcset', ss);
      if (s) img.setAttribute('src', s);
      img.removeAttribute('data-kl-srcset');
      img.removeAttribute('data-kl-src');
    });
  }
  // Delegated on document (not once), so tiles still load if the header is re-rendered later.
  ['pointerover', 'focusin', 'touchstart'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      if (e.target && e.target.closest && e.target.closest('#header-group, header, header-component')) load();
    }, { passive: true });
  });
  document.addEventListener('toggle', function (e) {
    if (e.target && e.target.open) load();
  }, true);
})();
